export default __webpack_public_path__ + "static/media/Asset5.6071bec0.svg";